import React from "react";
import {
	HashRouter as Router,
	Routes,
	Route,
	Navigate,
} from "react-router-dom";
import { Provider, useSelector } from "react-redux";
import store from "../src/Redux/Store";
import ProtectedRoutes from "./Routes/ProtectedRoutes";
import AuthRoutes from "./Routes/AuthRoutes";
import Layout from "./Layout/Layout";
import SessionTimeout from "./Hooks/SessionTimeout";
import { ToastContainer } from "react-toastify";

const App = () => {
	return (
		<Provider store={store}>
			<Router>
				<ToastContainer />
				<Routes>
					<Route path="auth/*" element={<AuthRoutes />} />

					<Route
						path="/*"
						element={
							<Layout>
								<ProtectedComponent />
							</Layout>
						}
					/>
				</Routes>
			</Router>
		</Provider>
	);
};

const ProtectedComponent = () => {
	const token = useSelector((state) => state.token.value);
	return token ? (
		<>
			<SessionTimeout timeoutDuration={1800000} />
			<ProtectedRoutes />
		</>
	) : (
		<Navigate to="/auth/login" replace />
	);
};

export default App;
